import { FilterOperator, SortDirection } from "@/components/search-filter-bar";

// Operator options for filter
export const operatorOptions = [
  { label: "Is", value: FilterOperator.IS },
  { label: "Is Not", value: FilterOperator.IS_NOT },
  { label: "Is Empty", value: FilterOperator.IS_EMPTY },
  { label: "Contains", value: FilterOperator.CONTAINS },
  // { label: "Starts With", value: FilterOperator.STARTS_WITH },
  { label: "Ends With", value: FilterOperator.ENDS_WITH },
];

// Sort direction options
export const sortDirectionOptions = [
  { label: "Ascending", value: SortDirection.ASC },
  { label: "Descending", value: SortDirection.DESC },
];
